$(function () {
  $('a[href^="#"]').click(function () {
    let speed = 500;
    let href = $(this).attr("href");
    let target = $(href == "#" || href == "" ? 'html' : href);
    let position = target.offset().top - 130;
    $("html, body").animate({ scrollTop: position }, speed, "swing");
    return false;
  });

  $(window).on('scroll', function () {
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    $('.effect-fade').each(function () {
      var elemPos = $(this).offset().top;
      if (scroll > elemPos - windowHeight) {
        $(this).addClass('effect-scroll');
      }
    });
  })

  new Splide('.js-auto-scroll', {
    type: 'loop',
    drag: true,
    arrows: false,
    pagination: false,
    autoWidth: true,
    gap: '10px',
    mediaQuery: 'min',
    breakpoints: {
      0: {
        autoScroll: { speed: 0.5, pauseOnHover: true, pauseOnFocus: true, }
      },
      880: {
        autoScroll: { speed: 1, pauseOnHover: true, pauseOnFocus: true, }
      }
    },
  }).mount(window.splide.Extensions);

  new Splide('.js-service-splide', {
    type: 'loop',
    drag: true,
    arrows: false,
    pagination: false,
    perMove: 1,
    autoplay: true,
    pauseOnHover: true,
    interval: 3000,
    speed: 1000,
    mediaQuery: 'min',
    breakpoints: {
      0: {
        gap: '11px',
        padding: "8%",
      },
      880: {
        gap: '24px',
        padding: "13%",
      }
    },
  }).mount();

  new Splide('.js-strap-splide01', {
    type: 'slide',
    drag: true,
    arrows: false,
    pagination: true,
    perMove: 1,
    perPage: 7,
    fixedWidth: '116px',
    gap: '12px',
    focus: 0,
    omitEnd: false,
    trimSpace: false,
  }).mount();

  new Splide('.js-strap-splide02', {
    type: 'slide',
    drag: true,
    arrows: false,
    pagination: true,
    perMove: 1,
    perPage: 7,
    fixedWidth: '116px',
    gap: '12px',
    focus: 0,
    omitEnd: false,
    trimSpace: false,
  }).mount();
})